import apiClient from '@/app/services/api-client';

let controller: AbortController | null = null;

export default {
  projectsByAToZ() {
    return apiClient.get('/maps/projects/ProjectsByAToZ', {
      setLoadingAction: true,
    });
  },
  projectsByLocation() {
    return apiClient.get('/maps/projects/ProjectsByLocation?location=', {
      setLoadingAction: true,
    });
  },
  projectsByName(searchTerm: string) {
    return apiClient.get(`/maps/projects/ProjectsByLocation?location=${searchTerm}`, {
      setLoadingAction: true,
    });
  },
  search(magicKey: string) {
    return apiClient.get(`/findarea/FullAddress?magicKey=${magicKey}`, {
      setLoadingAction: true,
    });
  },
  selectedFeatureSummary(selectedFeatureId: string) {
    return apiClient.get(`/maps/projects/SelectedFeatureSummary?id=${selectedFeatureId}`, {
      setLoadingAction: true,
    });
  },
  suggestions(suggestionsValue: string) {
    if (controller) {
      controller.abort();
    }
    controller = new AbortController();
    return apiClient
      .get(`/suggestions?value=${suggestionsValue}`, {
        signal: controller.signal,
        setLoadingAction: false,
      })
      .then((reseponse) => {
        controller = null;
        return reseponse;
      });
  },
};
